module.exports = __webpack_public_path__ + "img/no-data-jobs.76f49e11.svg";